'use client';

import { FC, useContext, useEffect, useState } from 'react';
import { AddFirmGroupProps } from './AddFirmGroup.types';
import { Button, ButtonGroup, Flex, Input } from '@/_components';
import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';

export const AddFirmGroup: FC<AddFirmGroupProps> = ({
  onAddFirmGroup,
  firmGroupId,
  onCancel,
}) => {
  const { firm } = useContext(FirmSettingsContext);
  const [name, setName] = useState<string>('');

  const onNameChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setName(event.target.value);

  const onSubmit = () => onAddFirmGroup(name);

  useEffect(() => {
    return () => setName('');
  }, []);

  useEffect(() => {
    if (firmGroupId) {
      const firmGroupName =
        firm?.firm_groups?.find((fg) => fg?.id === firmGroupId)?.name || '';

      console.log({ firmGroupName });
      setName(firmGroupName);
    }
  }, [firmGroupId, firm?.firm_groups]);

  return (
    <Flex gap={8} isColumn={true}>
      <Input
        label="Firm Group Name"
        placeholder="Firm Group Name"
        value={name}
        autoFocus={true}
        onChange={onNameChange}
        isLabelHidden={true}
      />
      <ButtonGroup isSameLine={true} align="right">
        <Button intent="ghost" value="Cancel" onClick={onCancel} />
        <Button
          intent="primary"
          value={firmGroupId ? 'Save' : 'Create'}
          onClick={onSubmit}
          isDisabled={!name}
        />
      </ButtonGroup>
    </Flex>
  );
};
